import { render } from "./LanggananBox.vue?vue&type=template&id=2f0d6302&scoped=true"
import script from "./LanggananBox.vue?vue&type=script&lang=js"
export * from "./LanggananBox.vue?vue&type=script&lang=js"

import "./LanggananBox.vue?vue&type=style&index=0&id=2f0d6302&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f0d6302"]])

export default __exports__